import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import type { RootDispatch, RootState } from './store';

// https://redux-toolkit.js.org/tutorials/typescript#define-typed-hooks
// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<RootDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
